import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { ff } from '@atlassian/jira-feature-flagging';

import { zIndex, columnHeaderHeight as headerHeight } from '../../../common/constants/styles';

export default function SwimlaneWrapper({
	flexibleColumns,
	minHeight,
	isVirtualised,
	hideTickMask, // Hide tick mask when the swimlane header is not rendered
	children,
}: {
	flexibleColumns?: boolean;
	minHeight?: number;
	isVirtualised?: boolean;
	hideTickMask?: boolean;
	children: ReactNode;
}) {
	return (
		<Wrapper
			flexibleColumns={flexibleColumns}
			isVirtualised={isVirtualised}
			// eslint-disable-next-line jira/react/no-style-attribute
			style={isVirtualised && minHeight ? { minHeight } : {}}
		>
			{(!ff('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m2') || !hideTickMask) && (
				<SwimlaneTickMask />
			)}
			{children}
		</Wrapper>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div<{
	flexibleColumns?: boolean;
	isVirtualised?: boolean;
}>({
	display: ({ isVirtualised }) => (isVirtualised ? 'block' : 'contents'),
	position: ({ isVirtualised }) => (isVirtualised ? 'relative' : 'static'),
	willChange: 'transform',
	width: ({ flexibleColumns }) => (flexibleColumns ? '100%' : 'auto'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SwimlaneTickMask = styled.div({
	position: 'sticky',
	top: 0,
	// marginTop needs to match header height

	marginTop: `-${headerHeight}px`,
	height: `${headerHeight}px`,
	background: token('elevation.surface', colors.N100),
	zIndex: zIndex.swimlaneTickMask,
	marginLeft: 0,
});
